import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SlotsController } from '@shared/src/controllers/address/slots/slots.controller';
import { HTags } from '@shared/src/datatypes/HTags';
import { SlotBlockingInfoDto } from '@shared/src/dtos/address/slots/SlotBlockingInfoDto';
import { HTriState } from '@shared/src/public-api';

@Component({
  selector: 'shared-slot-block-component',
  templateUrl: './shared.slot.block.component.html',
  styleUrls: ['./shared.slot.block.component.scss'],
})
export class SharedSlotBlockComponent implements OnInit {

  constructor(private slotsController: SlotsController) {}

  public generalClass: string = '';

  @Input() public readonly: boolean = false;

  private _slotId: number;
  @Input() set slotId(value: number) {
    if (this._slotId === value)
      return;
    this._slotId = value;
    this.loadData();
  }
  get slotId(): number {
    return this._slotId;
  }

  private _value: SlotBlockingInfoDto;
  set value(value: SlotBlockingInfoDto) {
    if (this._value === value)
      return;
    this._value = value;
    this.updateClass();
  }
  get value(): SlotBlockingInfoDto {
    return this._value;
  }

  ngOnInit() {

  }

  private loadData() {
    if (this.slotId == null)
      return;

    this.slotsController.getSlotBlockingInfo(this.slotId).subscribe(data => {
      this.value = data;
    });
  }

  onIsBlockedUserChanged(value: HTriState) {
     if (this.slotId == null)
      return;
    this.slotsController.setIsBlockedUser(this.slotId, value).subscribe(data => {
      this.value = data;
    });
  }

  onBlockTagsChagend(value: HTags) {
     if (this.slotId == null)
      return;
    this.slotsController.setSlotBlockedTags(this.slotId, value).subscribe(data => {
      this.value = data;
    });
  }

  public isUserBlocked: boolean;
  public updateClass() {
    this.generalClass = '';

    if (this.value == null)
      return;

    if (this.value.isBlockedSystem)
      this.generalClass += ' isSystemBlocked';
    else
      this.generalClass += ' noIsSystemBlocked';

    if (HTriState.isTrue(this.value.isBlockedUser)){
      this.generalClass += ' isUserBlocked';
      this.isUserBlocked = true;
    }else if (HTriState.isFalse(this.value.isBlockedUser)){
      this.generalClass += ' noIsUserBlocked';
      this.isUserBlocked = false;
    }else{
      this.generalClass += ' neutralUserBlocked';
      this.isUserBlocked = false;
    }
  }

}
